export default __webpack_public_path__ + "assets/images/Settings-01228b1f3a792352950b69875b32d304.svg";